export default "__VITE_ASSET__Ce9fVUJj__"